export class ExpandDesignerAction {
  static type = 'designer/EXPAND';
  constructor() {
    this.type = ExpandDesignerAction.type;
  }
}
